import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import SettingsIndex from '../components/management/settings/Index';

import * as chartingActions from '../actions/charting';

function mapStateToProps(state) {
    return {
        charting: state.charting,
        auth: state.auth,
        isLoading: state.isLoading
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(chartingActions, dispatch);
}

const Index = connect(mapStateToProps, mapDispatchToProps)(SettingsIndex);

export default Index;


/** WEBPACK FOOTER **
 ** ./src/containers/Settings.js
 **/